import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { vacancyService } from '../../services/api';
import { getUserData } from '../../utils/auth';
import './CompanyMyVacancies.css';

function CompanyMyVacancies() {
  const userData = getUserData();
  const companyId = userData?.companyId || userData?.CompanyId;

  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (companyId) loadVacancies();
    else setLoading(false);
  }, [companyId]);

  const loadVacancies = async () => {
    try {
      setLoading(true);
      const data = await vacancyService.getVacanciesByCompany(companyId);
      setVacancies(data);
    } catch (error) {
      alert('Error loading vacancies: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : '-');

  if (!companyId) {
    return (
      <div className="company-my-vacancies">
        <div className="page-header">
          <h1>My Vacancies</h1>
        </div>
        <p>Company session not found. Please log in again.</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="company-my-vacancies">
        <div className="page-header">
          <h1>My Vacancies</h1>
        </div>
        <p>Loading vacancies...</p>
      </div>
    );
  }

  return (
    <div className="company-my-vacancies">
      <div className="page-header">
        <h1>My Vacancies</h1>
        <p>Manage your posted vacancies</p>
      </div>
      <div className="vacancies-list">
        {vacancies.length === 0 ? (
          <p className="no-data">No vacancies posted yet. <Link to="/company-portal/post-vacancy">Post a vacancy</Link>.</p>
        ) : (
          <div className="vacancy-cards">
            {vacancies.map((v) => (
              <div key={v.Id} className="vacancy-card">
                <div className="vacancy-header">
                  <h3>{v.Title}</h3>
                  <span className="placement-badge">{v.PlacementDrive?.Title || 'Drive'}</span>
                </div>
                {v.Description && (
                  <p className="vacancy-desc">{v.Description.length > 150 ? v.Description.substring(0, 150) + '...' : v.Description}</p>
                )}
                <div className="vacancy-meta">
                  <span>📅 Posted: {formatDate(v.Date)}</span>
                  {v.LastDate && <span>⏰ Last date: {formatDate(v.LastDate)}</span>}
                </div>
                <Link to={`/company-portal/vacancy/${v.Id}`} className="view-link">
                  View vacancy & applications
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CompanyMyVacancies;
